var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isIframe
    ? _c("app-modal-item-iframe", {
        attrs: { modal: _vm.modal },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      })
    : _vm.isContactEdit
    ? _c("app-modal-item-contact-edit", {
        attrs: { modal: _vm.modal },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      })
    : _vm.isProductEdit
    ? _c("app-modal-item-product-edit", {
        attrs: { modal: _vm.modal },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }